import { Layout } from "antd";
import React, { useEffect } from "react";
import { useMediaQuery } from "react-responsive";
import { useNavigate } from "react-router-dom";
import { useLocalStorage } from "usehooks-ts";
import useDarkMode from "../../hooks/useDarkMode";
import useProDashboard from "../../hooks/useProDashboard";
import HTTPClient from "../../utils/HTTPClient";
import AppFooter from "./footer";
import AppHeader from "./header";
import MobileHeader from "./MobileHeader";
import AppSider from "./sider";
import ProAppSider from "./proSider";
import "./styles.css";
import { BorderBottomOutlined } from "@ant-design/icons";

const { Header, Footer, Sider, Content } = Layout;

const AppLayout = ({ children }) => {
    const [user, setUser] = useLocalStorage("user", null);
    const [darkMode] = useDarkMode();
    const [proDashboard] = useProDashboard();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchUser = async () => {
            let response = await HTTPClient.get("/auth/user");
            const logged_user = {
                ...response.data.user_data,
                wallet: response.data.wallet,
                is_profile_complete: response.data.is_profile_complete,
            };
            setUser(logged_user);
        };
        fetchUser();
    }, [navigate]);

    const isLargeScreen = useMediaQuery({
        query: "(min-width: 1310px)",
    });

    let headerStyle = {
        height: "70px",
        backgroundColor: darkMode ? "#141414" : "white",
        //padding: isLargeScreen ? "15px 20px" : "0px 10px",
        position: "fixed",
        right: 0,
        top: 0,
        width: "100%",
        zIndex: 1000,
        padding: "0px 20px",
        //borderBottom: "1px dashed #1C2347"
        boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)"
    };

    if (!isLargeScreen) {
        headerStyle = {
            ...headerStyle,
            position: "fixed",
            width: "100%",
            zIndex: 1000,
            top: "0px",
            left: "0px",
        };
    }

    return (
        <Layout style={{ minHeight: "100vh" }}>
            {user && isLargeScreen ? (
                <Sider
                    breakpoint={"md"}
                    collapsible={false}
                    className={darkMode ? "appbox-dark" : "appbox-light"}
                    width={300}
                    style={{
                        overflow: "auto",
                        height: "100vh",
                        position: "sticky",
                        top: 0,
                        left: 0,
                        padding: 0,
                        borderRadius: "0px 18px 18px 0px",
                        backgroundColor: "#1C2347",
                        zIndex: 1001
                    }}>
                    {proDashboard ? <ProAppSider /> : <AppSider />}
                </Sider>
            ) : null}
            <Layout>
                <Header style={headerStyle}>
                    {isLargeScreen ? <AppHeader /> : <MobileHeader />}
                </Header>
                <Content style={{ minHeight: "84vh", marginTop: "70px" }}>
                    {children}
                </Content>
            </Layout>
        </Layout>
    );
};

export default AppLayout;
